class CheckoutItem extends HTMLElement {
  constructor() {
    super();
    this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent).variants;
    this.addEventListener('change', this.handleChange.bind(this));
    this.checkoutLink = this.querySelector('a[checkout-link]');
    // this.images = this.querySelectorAll('img[variant-id]');
  }

  handleChange(event) {
    this.updateCheckoutLink(event.target);
    // this.images.forEach(image => {
    //   if (image.getAttribute('variant-id') === event.target.value) {
    //     image.classList.add('active');
    //   } else {
    //     image.classList.remove('active');
    //   }
    // });
    
  }

  updateCheckoutLink(input) {
    if (!this.checkoutLink || !input) return;

    const checkoutVariantId = input.getAttribute('data-checkout-variant-id') || input.value;
    const checkoutProperties = input.getAttribute('data-checkout-properties');

    if (checkoutVariantId) {
      this.checkoutLink.href = this.buildCartPermalink(checkoutVariantId, checkoutProperties);
    }
  }

  buildCartPermalink(variantId, properties) {
    const cartUrl = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
    const permalink = `${cartUrl}/${variantId}:1`;

    if (!properties) {
      return permalink;
    }

    return `${permalink}?properties=${encodeURIComponent(properties)}`;
  }
}


customElements.define('checkout-item', CheckoutItem);
